import { drawDOM, Group,
    // exportPDF 
} from "@progress/kendo-drawing";
import { exportPDF, saveAs } from "@progress/kendo-drawing/pdf";
import { currentDateTo_DDMMMYY_Format, currentDateTo_DDMMYYYY_Format } from "./dateTimeHelper";
import { saveAs as fileSaver } from 'file-saver';

export const savePdfProxy = (element: string, formValues: any, quoteNumber: string) => {
  let gridElement = document.querySelector<HTMLInputElement>(element);
  if (gridElement) {
    let currentDate = currentDateTo_DDMMYYYY_Format();
    drawDOM(gridElement, {
        paperSize: "A4",
        forcePageBreak: ".page-break",
        margin: {top: 0, right: "1.5cm", bottom: "1.5cm", left: "1.5cm"},
        template: (data) =>
        `<div style="display: flex; justify-content: space-between; width: 100%;">
            <span style="font-size: 11px;">
            Page ${data.pageNum}
            </span>
            <span style="font-size: 11px;">
            ${currentDate}
            </span>
        </div>`,
    }).then((group: Group) => {
        return saveAs(group, 
            generateFileName(formValues, quoteNumber)
        );
    })
  }
}

export const drawToGroup = async (element: string) => {
    let gridElement = document.querySelector<HTMLInputElement>(element);
    if (gridElement) {
      let currentDate = currentDateTo_DDMMYYYY_Format();
      return await drawDOM(gridElement, {
          paperSize: "A4",
          margin: {top: 0, right: "1cm", bottom: "1cm", left: "1cm"},
          scale: 0.9,
          template: (data) =>
          `<div style="display: flex; justify-content: space-between; width: 100%;">
              <span style="font-size: 11px;">
              Page ${data.pageNum}
              </span>
              <span style="font-size: 11px;">
              ${currentDate}
              </span>
          </div>`,
      })
    //   .then((group: Group) => {
    //       return group;
    //   });
    }
}

export const saveAsPdfFile = (group: Group, formValues: any, quoteNumber: string) => {
    return saveAs(group, generateFileName(formValues, quoteNumber));
}

export const saveAsBlobFile = (group: Group) => {
    return exportPDF(group).then(async (dataURI: string) => {
        // console.log(dataURI.split(";base64,")[0]);
        let myBlob = await convertBase64ToBlob(dataURI);
        // console.log(URL.createObjectURL(myBlob));
        return myBlob;
    });
}

// Convert Blob to Base64
export const convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
        resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });
  
// Convert Base64 to Blob
export const convertBase64ToBlob = async (base64Data: string) => {
    const base64 = await fetch(base64Data);
    return await base64.blob();
}

export const generateFileName = (formValues: any, quoteNumber: string) => {
    let currentDate = currentDateTo_DDMMMYY_Format();
    let str = "Quote_" + quoteNumber + "_";
    // customer name
    let clientName = "";
    if (formValues?.first_name || formValues?.last_name) {
      clientName = (formValues?.first_name ? formValues?.first_name : '') + ' ' + (formValues?.last_name ? formValues?.last_name : '');
    } else {
      clientName = "(No name)";
    }
    str = str + clientName.replaceAll(' ', '_') + "_";
    // locality
    str = str + (formValues?.locality ? formValues?.locality : '').replaceAll(' ', '_') + "_";
    // state postcode
    str = str + (formValues?.state ? formValues?.state : '').replaceAll(' ', '_') + "_" + (formValues?.zip ? formValues?.zip : '') + "_";
    // sanden name
    try {
        let productChoice = JSON.parse(formValues?.product_choice);
        let sandenName = "";
        if (productChoice) {
            for (var key in productChoice) {
                if (productChoice.hasOwnProperty(key)) {
                    sandenName = productChoice[key].shortName;
                }
            }
        }
        str = str + "Tesla";
        return str + currentDate + ".pdf";
    } catch (err) {
        str = str + "Battery_undefined_";
        return str + currentDate + ".pdf";
    }
}

export const savePdfFromUrl = (url: string, filePath: string, fileName: string) => {
    const formData = new FormData();
    formData.append('filePath', filePath);

    fetch(url, {
        method: 'POST',
        body: formData,
    })
    .then((response) => response.blob())
    .then((blob) => {
        // save to file
        fileSaver(blob, fileName);
    });
}